import { PlatformIntegration } from "types/interfaces/adminUsers";

/** Strip leading "[Method] " prefix from integration_name (same as Client & User Setup folders chip logic). */
export function parseIntegrationMethodPrefix(name: string): {
  methodType: string | null;
  displayName: string;
} {
  const match = name.match(/^\[([^\]]+)\]\s*/);
  if (match) {
    return { methodType: match[1], displayName: name.slice(match[0].length) };
  }
  return { methodType: null, displayName: name };
}

/** Primary list label: owner first name + integration display, aligned with folder_display in platform_views. */
export function getPlatformIntegrationDisplayName(
  integration: PlatformIntegration,
): string {
  const { displayName } = parseIntegrationMethodPrefix(integration.integration_name);
  const owner = (integration.owner_first_name || "").trim();
  return owner ? `${owner} - ${displayName}` : displayName;
}

export function getPlatformIntegrationTooltipTitle(
  integration: PlatformIntegration,
): string {
  return integration.integration_name;
}
